var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoflag = function SvgNoflag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h21v15H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7de75d15-553d-4b8a-9b3f-81b19035d9c6a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2e514c56-141a-443c-b467-0c56cce20ca9b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2e514c56-141a-443c-b467-0c56cce20ca9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ba9ae2c-4bf3-4866-ae95-571cc8e0aff6c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7E808A",
    fillRule: "evenodd",
    d: "M7.146 7.125h1.498a6.1 6.1 0 0 1 1.003-2.891 3.38 3.38 0 0 0-2.501 2.891M10.5 4.332a5.36 5.36 0 0 0-1.103 2.793h2.206A5.36 5.36 0 0 0 10.5 4.332m1.103 3.543a5.36 5.36 0 0 1-1.103 2.794 5.36 5.36 0 0 1-1.103-2.794zm-2.96 0H7.147a3.38 3.38 0 0 0 2.501 2.891 6.1 6.1 0 0 1-1.003-2.891m2.71 2.891c.572-.86.92-1.855 1.003-2.891h1.498a3.38 3.38 0 0 1-2.501 2.891m2.501-3.641h-1.498a6.1 6.1 0 0 0-1.003-2.891 3.38 3.38 0 0 1 2.501 2.891M6.375 7.5a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7de75d15-553d-4b8a-9b3f-81b19035d9c6a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6ba9ae2c-4bf3-4866-ae95-571cc8e0aff6c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 3h9v9H6z"
  })))));
};
export default SvgNoflag;